import React, {createContext, useContext, useState} from "react";
import {useMutation} from "@tanstack/react-query";
import {request} from '../../../Infrastructure';
import {createLeadsForm} from '../../queries';
import {FormattedMessage} from 'react-intl';

type FormattedMessageType = {
    props: {
        id: string;
    };
    type: {
        displayName: string;
    };
};

export type CreateFormRequestType = {
    lastName: string;
    firstName: string;
    email: string;
    phone: string;
    region: string;
    message?: string;
    productSku: string;
    title?: string | FormattedMessageType;
};

type ContextFormStateType = {
    handleCreateForm: (formData: CreateFormRequestType) => void;
    productSku: string;
    successMessage: string;
    errorMessage: string;
    loading: boolean;
};

const ContextFormStateContext = createContext<ContextFormStateType | undefined>(undefined);

export const ContextFormsProvider: React.FC<{ children: React.ReactNode, productSku: string}> = ({ children, productSku }) => {
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const mutation = useMutation((formData: CreateFormRequestType) =>
        request(createLeadsForm, {input: formData}),
        {
            onSuccess: (data) => {
                if (data.data.createLeadsForm.success) {
                    setSuccessMessage("crm_form_success");
                }
            },
            onError: (error: any) => {
                setErrorMessage("crm_form_error");
                setSuccessMessage('');
            }
        }
    );

    const handleCreateForm = (formData: CreateFormRequestType) => {
        // Procesăm datele înainte de a le trimite
        const titleId = typeof formData.title === 'string' 
            ? formData.title 
            : formData.title?.props?.id || '';
            
        const processedData = {
            ...formData,
            title: titleId
        };
        
        mutation.mutate(processedData);
    }

    return (
        <ContextFormStateContext.Provider value={{
            handleCreateForm,
            productSku,
            successMessage,
            errorMessage,
            loading: mutation.isLoading
        }}>
            {children}
        </ContextFormStateContext.Provider>
    );
}

export const useContextFormsState = () => {
    const context = useContext(ContextFormStateContext);
    if (context === undefined) {
        throw new Error("useContextFormState must be used within a ContextFormProvider");
    }
    return context;
}
